import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { RevisionModel } from '../../../../api/api.types';
import { useTranslation } from 'react-i18next';
import { CoreApi } from '../../../../api/api.apiclient';
import AuditLog from '../../../../components/tables/AuditLog';

interface DeskAuditLogLocationProps {
  code: string;
}

const DeskAuditLog: React.FC<RouteComponentProps<DeskAuditLogLocationProps>> =
  (props) => {

    const [ revisions, setRevisions ] = useState<RevisionModel[]>([]);
    const [ isLoading, setIsLoading ] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
      const code = props.match.params.code;
      CoreApi.Desks.getDeskRevisions(code)
        .then((resp) => setRevisions(resp.data))
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false));
    }, [ props.match.params, t ]);

    return (
      <div className="page-content">
        <div className="row justify-content-end pb-2">
          <div className="col-12">
            <h1 className="mb-0">Desk {props.match.params.code} audit log</h1>
          </div>
        </div>
        <AuditLog
          revisions={revisions}
          jsonFieldNames={[ 'mandatoryItems' ]}
        />
      </div>
    );
  };
export default DeskAuditLog;